import { P0, S, abs, fillAt, max } from '../../geometry';

export const kettle = {
  name: 'Kettle',
  colors: ['#12A594', '#161616'],
  draw(m, t) {
    let steam = 0.35,
      sp = 1.5,
      knob = 0,
      pose = P0();
    if (m === 'happy') {
      steam = 1;
      sp = 5;
      pose.ty = -2 * abs(S(t * 6));
    }
    // Thinking: steam keeps curling up and the lid rattles.
    if (m === 'thinking') {
      steam = 1;
      sp = 4;
      knob = -2.5 * abs(S(t * 9));
      pose.rot = 2 * S(t * 12);
    }
    if (m === 'talking') {
      steam = 0.7;
      knob = -2 * max(0, S(t * 10));
    }
    if (m === 'surprised') {
      steam = 1;
      sp = 8;
      knob = -7;
    }
    if (m === 'paused') {
      steam = 0;
      pose.rot = -4 + S(t * 0.7);
    }
    const body = [
      [30, 82],
      [24, 67],
      [29, 51],
      [50, 46],
      [71, 51],
      [76, 67],
      [70, 82],
      [30, 82],
    ];
    const wisp = (k) => ({
      c: 'b',
      pts: [0, 1, 2, 3].map((j) => [
        88 + k * 6 + 2.6 * S(t * sp - j * 1.3 + k),
        44 - j * 7,
      ]),
      o: steam * (k ? 0.6 : 1),
      detail: true,
    });
    return {
      strokes: [
        { c: 'a', pts: body, n: 20 },
        {
          c: 'a',
          pts: [
            [44, 46 + knob],
            [50, 40 + knob],
            [56, 46 + knob],
          ],
        },
        {
          c: 'a',
          pts: [
            [74, 63],
            [84, 57],
            [89, 48],
          ],
        },
        {
          c: 'a',
          pts: [
            [28, 55],
            [16, 57],
            [16, 70],
            [26, 75],
          ],
        },
        wisp(0),
        wisp(1),
      ],
      eyes: { x: 50, y: 64 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0),
};
